import React, { Component } from 'react';
import TeamItem from '../components/TeamItem'; 
import Flexbox from '../components/misc/Flexbox'; 

class Team extends Component {

	render(){
		const {left,right,items} = this.props;
		return(
			<div className="container-fluid lg-side-padding">
				<div className="row">
					<div className="col-md-12">
						<Flexbox left={left} right={right} />
						
						<section className="team-list">
							{
								items.map( (data,i)=>
									<TeamItem {...data} key={i} />
								)
							}
						</section>
					</div>
				</div>
			</div>
		)
	}	
}
export default Team;


// WEBPACK FOOTER //
// ./src/components/Team.js